export default "__VITE_ASSET__CvHrUMmE__"